import React, { useState, useEffect } from "react";
import axios from "../../api/axios";
import { useNavigate } from "react-router-dom";
import Navbar from "../navsidebar/navbar";
import Sidebar from "../navsidebar/sidebar";
import { FaPlusCircle, FaEdit } from "react-icons/fa";

export default function RetailInventory() {
  const [items, setItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [quantity, setQuantity] = useState("");
  const [mode, setMode] = useState("");
  const [selectedSku, setSelectedSku] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editedBatches, setEditedBatches] = useState([]);
  const [showupdateModal, setupdateShowModal] = useState(false);

  const { businessEntityId: business_entity_id } = JSON.parse(sessionStorage.getItem("userData"));


  // Fetch inventory items
  useEffect(() => {
    const fetchInventory = async () => {
      try {
        const response = await axios.get(
          `/retail/getItemsInventory/${business_entity_id}`
        );
        setItems(response.data);
      } catch (error) {
        console.error("Error fetching inventory:", error);
      }
    };
    fetchInventory();
  }, [business_entity_id]);

  // Handle Add or Update
  const handleSubmit = async () => {
    try {
      if (!quantity || quantity <= 0) {
        alert("Quantity must be greater than 0");
        return;
      }

      if (mode === "add") {

        await axios.post(`/retail/addInventory/${selectedItem.item_id}`, {
          businessEntityId: business_entity_id,
          quantity,
          product_sku: selectedSku === "new" ? 0 : selectedSku,
          expiry_date: expiryDate || null,
        });
        alert("Inventory added successfully!");
      } else if (mode === "update") {
        await axios.put(`/retail/updateInventory/${selectedItem.item_id}`, {
          businessEntityId: business_entity_id,
          quantity,
        });
        alert("Inventory updated successfully!");
      }

      setShowModal(false);
      setQuantity("");
      setSelectedItem(null);

      // Refresh inventory list
      const response = await axios.get(
        `/retail/getItemsInventory/${business_entity_id}`
      );
      setItems(response.data);
    } catch (error) {
      console.error("Error updating inventory:", error);
      alert("Failed to update inventory.");
    }
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar />
      <div className="flex flex-col w-full">
        <Navbar />
        <div className="p-6 bg-gray-50 min-h-screen">
          <h1 className="text-2xl font-bold text-gray-700 mb-6">
            Inventory Management
          </h1>

          {/* Item List */}
          <div className="overflow-x-auto bg-white shadow-md rounded-lg">
            <table className="w-full table-auto border-collapse">
              <thead>
                <tr className="bg-gray-200 text-gray-700">
                  <th className="p-3 text-left">Item Name</th>

                  <th className="p-3 text-center">Price</th>
                  <th className="p-3 text-center">Available Qty</th>
                  <th className="p-3 text-center">Total Purchase</th>
                  <th className="p-3 text-center">Last Received Date</th>
                  <th className="p-3 text-center">Earliest Expiry Date</th>
                  <th className="p-3 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr
                    key={item.item_id}
                    className="border-b hover:bg-gray-50 transition"
                  >
                    <td className="p-3">{item.name}</td>

                    <td className="p-3 text-center">₹{item.price}</td>
                    <td className="p-3 text-center">{item.total_quantity}</td>
                    <td className="p-3 text-center">{item.total_purchased_quantity}</td>
                    <td className="p-3 text-center">
                      {item.last_received_date
                        ? new Date(item.last_received_date).toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",

                        })
                        : "N/A"}
                    </td>
                    <td className="p-3 text-center">
                      {item.earliest_expiry_date
                        ? new Date(item.earliest_expiry_date).toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",

                        })
                        : "N/A"}
                    </td>
                    <td className="p-3 flex gap-3 justify-center">
                      <button
                        className="bg-green-500 text-white px-3 py-1 rounded flex items-center gap-1 hover:bg-green-600"
                        onClick={() => {
                          setSelectedItem(item);
                          setMode("add");
                          setQuantity('');
                          setShowModal(true);
                        }}
                      >
                        <FaPlusCircle /> Add Purchase
                      </button>
                      <button
                        className={`px-3 py-1 rounded flex items-center gap-1 ${item.total_purchased_quantity > 0
                            ? "bg-blue-500 text-white hover:bg-blue-600"
                            : "bg-gray-300 text-gray-500 cursor-not-allowed"
                          }`}
                        disabled={item.total_purchased_quantity === 0}
                        onClick={() => {
                          setSelectedItem(item);
                          setEditedBatches(item.batches.map(b => ({ ...b })));
                          setupdateShowModal(true);
                        }}
                      >
                        <FaEdit /> Update
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Modal for Add/Update */}
          {showModal && (
            <div className="fixed inset-0 bg-opacity-40 flex justify-center items-center">
              <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-xl font-semibold mb-4">
                  Add Inventory
                </h2>

                <p className="mb-2">
                  Item: <strong>{selectedItem?.name}</strong>
                </p>

                {/* Quantity input */}
                <input
                  type="number"
                  className="w-full border rounded p-2 mb-4"
                  placeholder="Enter quantity"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                />

                {/* SKU dropdown */}
                <select
                  className="w-full border rounded p-2 mb-4"
                  value={selectedSku}
                  onChange={(e) => setSelectedSku(e.target.value)}
                >
                  <option value="">Select SKU</option>
                  {selectedItem?.product_sku_list?.map((sku, index) => (
                    <option key={index} value={sku}>
                      {sku}
                    </option>
                  ))}
                  <option value="new">➕ Add New Batch</option>
                </select>

                {/* Show new SKU + expiry if "Add New Batch" */}
                {selectedSku === "new" && (
                  <>
                    <p className="mb-2">
                      Expriry Date (optional):
                    </p>
                    {/* Expiry date input */}
                    <input
                      type="date"
                      className="w-full border rounded p-2 mb-4"
                      value={expiryDate}
                      onChange={(e) => setExpiryDate(e.target.value)}
                    />
                  </>
                )}

                <div className="flex justify-end gap-3">
                  <button
                    className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          )}

          {showupdateModal && (
            <div className="fixed inset-0 bg-opacity-40 flex justify-center items-center z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-[700px]">
                <h2 className="text-xl font-semibold mb-4">Update Batches</h2>

                <p className="mb-2">
                  Item: <strong>{selectedItem?.name}</strong>
                </p>

                <table className="w-full border text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border p-2">SKU</th>
                      <th className="border p-2">Quantity</th>
                      <th className="border p-2">Received Date</th>
                      <th className="border p-2">Expiry Date</th>

                    </tr>
                  </thead>
                  <tbody>
                    {editedBatches.map((batch, index) => (
                      <tr key={index}>
                        <td className="border p-2 text-center">{batch.product_sku}</td>
                        <td className="border p-2">
                          <input
                            type="number"
                            value={batch.quantity}
                            onChange={(e) => {
                              const updated = [...editedBatches];
                              updated[index].quantity = e.target.value;
                              setEditedBatches(updated);
                            }}
                            className="border rounded p-1 w-full"
                          />
                        </td>
                        <td className="border p-2">
                          <input
                            type="date"
                            value={batch.received_date ? batch.received_date.split("T")[0] : ""}
                            onChange={(e) => {
                              const updated = [...editedBatches];
                              updated[index].received_date = e.target.value;
                              setEditedBatches(updated);
                            }}
                            className="border rounded p-1 w-full"
                          />
                        </td>
                        <td className="border p-2">
                          <input
                            type="date"
                            value={batch.expiry_date ? batch.expiry_date.split("T")[0] : ""}
                            onChange={(e) => {
                              const updated = [...editedBatches];
                              updated[index].expiry_date = e.target.value;
                              setEditedBatches(updated);
                            }}
                            className="border rounded p-1 w-full"
                          />
                        </td>

                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="flex justify-end gap-3 mt-4">
                  <button
                    className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
                    onClick={() => setupdateShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                    onClick={async () => {
                      try {

                        await axios.put(`/retail/updateInventory/${selectedItem.item_id}`, {
                          businessEntityId: business_entity_id,
                          batches: editedBatches,
                        });
                        alert("Batches updated successfully!");
                        setupdateShowModal(false);

                        // Refresh list
                        const response = await axios.get(
                          `/retail/getItemsInventory/${business_entity_id}`
                        );
                        setItems(response.data);
                      } catch (error) {
                        console.error("Error updating batches:", error);
                        alert("Failed to update batches.");
                      }
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          )}


        </div>
      </div>
    </div>
  );
}
